import { loadCSS } from '../../utils';
let view = null;

export default {
	namespace: 'template-home',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPDATA.themeUrl + '/dist/css/t-home.css');

		const { default: TemplateHome } = await import(
			/* webpackChunkName: "template-home" */ '../../templates/TemplateHome'
		);
		view = new TemplateHome(next.container);

		if (view.reduceMotionMediaQuery.matches) {
			await view.init(0);
			view.skipIntro();
		} else {
			await view.init(-1);
			if(trigger === 'barba') {
				view.initIntro(false);
			} else {
				view.initIntro(true);
			}
		}
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
